let _profUserId = 'default'; try { require('@react-native-async-storage/async-storage').default.getItem('userToken').then(function(t){if(t)_profUserId=t.slice(0,16);}).catch(function(){}); } catch(e) {}
import React, { useState, useRef, useEffect, useCallback } from 'react';
import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  ScrollView,
  SafeAreaView,
  TextInput,
  Modal,
  Pressable,
  Alert,
  Image,
  FlatList,
  Animated,
  StatusBar,
  Dimensions,
  RefreshControl,
  ActivityIndicator,
  Linking,
  KeyboardAvoidingView,
  Platform,
  Switch,
} from 'react-native';
import {
  Ionicons,
  MaterialIcons,
  MaterialCommunityIcons,
  FontAwesome5,
  AntDesign,
  Feather,
} from '@expo/vector-icons';
import { useFocusEffect } from '@react-navigation/native';
import AsyncStorage from '@react-native-async-storage/async-storage';

const { width, height } = Dimensions.get('window');

// ** NETWORKING SERVICE **
const NetworkingService = {
  async getAllContacts() {
    try {
      console.log('🔄 Loading networking contacts...');
      
      const keys = await AsyncStorage.getAllKeys();
      const contactKeys = keys.filter(key => key.startsWith('contact_'));
      
      if (contactKeys.length === 0) {
        console.log('📝 No stored contacts found, using mock data');
        return this.getMockContacts();
      }
      
      const contacts = await AsyncStorage.multiGet(contactKeys);
      const parsedContacts = contacts
        .map(([key, value]) => value ? JSON.parse(value) : null)
        .filter(contact => contact !== null);
      
      console.log(`✅ Loaded ${parsedContacts.length} contacts from storage`);
      return parsedContacts;
      
    } catch (error) {
      console.error('❌ Error loading contacts:', error);
      return this.getMockContacts();
    }
  },

  getMockContacts() {
    return [
      {
        id: 'contact_001',
        name: 'Sarah Johnson',
        title: 'Senior Software Engineer',
        company: 'TechCorp London',
        industry: 'Technology',
        location: 'London, UK',
        avatar: { uri: 'https://via.placeholder.com/60/0e4e96/FFFFFF?text=SJ' },
        connectionType: 'linkedin',
        connectionDate: '2025-01-15',
        mutualConnections: 12,
        skills: ['React', 'Node.js', 'TypeScript', 'AWS'],
        bio: 'Passionate about building scalable web applications and mentoring junior developers.',
        linkedin: 'https://linkedin.com/in/sarahjohnson',
        email: 'sarah.johnson@techcorp.com',
        phone: '+44 20 1234 5678',
        lastContact: '2025-01-20',
        notes: 'Met at React London meetup. Interested in discussing frontend architecture.',
        tags: ['Frontend', 'Mentor', 'React Expert'],
        status: 'active',
        strength: 'strong',
      },
      {
        id: 'contact_002',
        name: 'Michael Chen',
        title: 'Product Manager',
        company: 'StartupHub Manchester',
        industry: 'Technology',
        location: 'Manchester, UK',
        avatar: { uri: 'https://via.placeholder.com/60/10B981/FFFFFF?text=MC' },
        connectionType: 'event',
        connectionDate: '2025-01-10',
        mutualConnections: 8,
        skills: ['Product Strategy', 'Agile', 'User Research', 'Analytics'],
        bio: 'Product leader with 8+ years experience building user-centric digital products.',
        linkedin: 'https://linkedin.com/in/michaelchen',
        email: 'michael.chen@startuphub.com',
        phone: '+44 161 234 5678',
        lastContact: '2025-01-18',
        notes: 'Great insights on product-market fit. Potential collaboration opportunity.',
        tags: ['Product', 'Strategy', 'Startup'],
        status: 'active',
        strength: 'medium',
      },
      {
        id: 'contact_003',
        name: 'Emma Wilson',
        title: 'UX Designer',
        company: 'DesignStudio Pro',
        industry: 'Design',
        location: 'Birmingham, UK',
        avatar: { uri: 'https://via.placeholder.com/60/8B5CF6/FFFFFF?text=EW' },
        connectionType: 'referral',
        connectionDate: '2025-01-05',
        mutualConnections: 15,
        skills: ['UI/UX Design', 'Figma', 'User Research', 'Prototyping'],
        bio: 'Award-winning UX designer specializing in fintech and healthcare applications.',
        linkedin: 'https://linkedin.com/in/emmawilson',
        email: 'emma.wilson@designstudio.com',
        phone: '+44 121 234 5678',
        lastContact: '2025-01-12',
        notes: 'Excellent portfolio. Could provide design feedback on current projects.',
        tags: ['Design', 'UX', 'Healthcare'],
        status: 'active',
        strength: 'strong',
      },
      {
        id: 'contact_004',
        name: 'David Brown',
        title: 'Engineering Manager',
        company: 'FinTech Solutions',
        industry: 'Financial Services',
        location: 'Edinburgh, UK',
        avatar: { uri: 'https://via.placeholder.com/60/F59E0B/FFFFFF?text=DB' },
        connectionType: 'linkedin',
        connectionDate: '2024-12-20',
        mutualConnections: 22,
        skills: ['Team Leadership', 'System Architecture', 'DevOps', 'Fintech'],
        bio: 'Engineering leader building secure, scalable financial technology solutions.',
        linkedin: 'https://linkedin.com/in/davidbrown',
        email: 'david.brown@fintech.com',
        phone: '+44 131 234 5678',
        lastContact: '2025-01-08',
        notes: 'Hiring for senior roles. Keep in touch for future opportunities.',
        tags: ['Management', 'Fintech', 'Hiring'],
        status: 'active',
        strength: 'medium',
      },
      {
        id: 'contact_005',
        name: 'Lisa Garcia',
        title: 'Data Scientist',
        company: 'AI Innovations Ltd',
        industry: 'Artificial Intelligence',
        location: 'Cambridge, UK',
        avatar: { uri: 'https://via.placeholder.com/60/06B6D4/FFFFFF?text=LG' },
        connectionType: 'conference',
        connectionDate: '2024-11-15',
        mutualConnections: 6,
        skills: ['Machine Learning', 'Python', 'Data Analysis', 'AI Research'],
        bio: 'PhD in Machine Learning, passionate about applying AI to solve real-world problems.',
        linkedin: 'https://linkedin.com/in/lisagarcia',
        email: 'lisa.garcia@aiinnovations.com',
        phone: '+44 1223 234 567',
        lastContact: '2024-12-15',
        notes: 'Met at AI Summit. Interested in ML applications in job matching.',
        tags: ['AI', 'Research', 'Data Science'],
        status: 'inactive',
        strength: 'weak',
      },
      {
        id: 'contact_006',
        name: 'Robert Kim',
        title: 'DevOps Engineer',
        company: 'CloudTech Systems',
        industry: 'Cloud Computing',
        location: 'London, UK',
        avatar: { uri: 'https://via.placeholder.com/60/EF4444/FFFFFF?text=RK' },
        connectionType: 'linkedin',
        connectionDate: '2025-01-25',
        mutualConnections: 18,
        skills: ['AWS', 'Docker', 'Kubernetes', 'CI/CD'],
        bio: 'Cloud infrastructure specialist helping companies scale their DevOps practices.',
        linkedin: 'https://linkedin.com/in/robertkim',
        email: 'robert.kim@cloudtech.com',
        phone: '+44 20 8765 4321',
        lastContact: '2025-01-25',
        notes: 'Recent connection. Expertise in cloud migration strategies.',
        tags: ['DevOps', 'Cloud', 'AWS'],
        status: 'active',
        strength: 'new',
      },
    ];
  },

  async getAllEvents() {
    try {
      console.log('🔄 Loading networking events...');
      
      const keys = await AsyncStorage.getAllKeys();
      const eventKeys = keys.filter(key => key.startsWith('event_'));
      
      if (eventKeys.length === 0) {
        console.log('📝 No stored events found, using mock data');
        return this.getMockEvents();
      }
      
      const events = await AsyncStorage.multiGet(eventKeys);
      const parsedEvents = events
        .map(([key, value]) => value ? JSON.parse(value) : null)
        .filter(event => event !== null);
      
      console.log(`✅ Loaded ${parsedEvents.length} events from storage`);
      return parsedEvents;
      
    } catch (error) {
      console.error('❌ Error loading events:', error);
      return this.getMockEvents();
    }
  },

  getMockEvents() {
    return [
      {
        id: 'event_001',
        title: 'React London Meetup',
        type: 'Meetup',
        date: '2025-02-15',
        time: '18:30',
        location: 'TechHub London',
        address: '20 Ropemaker St, London EC2Y 9AR',
        description: 'Monthly React meetup featuring talks on latest React features and best practices.',
        organizer: 'React London Community',
        attendees: 85,
        maxAttendees: 100,
        price: 'Free',
        image: { uri: 'https://via.placeholder.com/300x150/0e4e96/FFFFFF?text=React+Meetup' },
        tags: ['React', 'Frontend', 'JavaScript'],
        status: 'upcoming',
        rsvp: false,
        website: 'https://reactlondon.com',
        linkedin: 'https://linkedin.com/company/react-london',
      },
      {
        id: 'event_002',
        title: 'Tech Career Fair 2025',
        type: 'Career Fair',
        date: '2025-02-20',
        time: '10:00',
        location: 'ExCeL London',
        address: 'One Western Gateway, Royal Victoria Dock, London E16 1XL',
        description: 'Connect with top tech companies and explore career opportunities in London.',
        organizer: 'TechCareers UK',
        attendees: 1200,
        maxAttendees: 1500,
        price: '£15',
        image: { uri: 'https://via.placeholder.com/300x150/10B981/FFFFFF?text=Career+Fair' },
        tags: ['Career', 'Jobs', 'Networking'],
        status: 'upcoming',
        rsvp: true,
        website: 'https://techcareerfair.co.uk',
        linkedin: 'https://linkedin.com/company/techcareers-uk',
      },
      {
        id: 'event_003',
        title: 'AI & Machine Learning Summit',
        type: 'Conference',
        date: '2025-03-05',
        time: '09:00',
        location: 'The Brewery, London',
        address: 'Chiswell St, London EC1Y 4SD',
        description: 'Two-day conference exploring the latest developments in AI and machine learning.',
        organizer: 'AI Research Institute',
        attendees: 450,
        maxAttendees: 500,
        price: '£299',
        image: { uri: 'https://via.placeholder.com/300x150/8B5CF6/FFFFFF?text=AI+Summit' },
        tags: ['AI', 'Machine Learning', 'Research'],
        status: 'upcoming',
        rsvp: false,
        website: 'https://aisummit.london',
        linkedin: 'https://linkedin.com/company/ai-research-institute',
      },
      {
        id: 'event_004',
        title: 'Startup Pitch Night',
        type: 'Networking',
        date: '2025-02-28',
        time: '19:00',
        location: 'WeWork Moorgate',
        address: '1 Fore St Ave, London EC2Y 9DT',
        description: 'Watch innovative startups pitch their ideas and network with entrepreneurs.',
        organizer: 'London Startup Community',
        attendees: 120,
        maxAttendees: 150,
        price: '£25',
        image: { uri: 'https://via.placeholder.com/300x150/F59E0B/FFFFFF?text=Startup+Pitch' },
        tags: ['Startup', 'Entrepreneurship', 'Pitch'],
        status: 'upcoming',
        rsvp: true,
        website: 'https://londonstartups.com',
        linkedin: 'https://linkedin.com/company/london-startup-community',
      },
      {
        id: 'event_005',
        title: 'Women in Tech Breakfast',
        type: 'Networking',
        date: '2025-02-12',
        time: '08:00',
        location: 'The Shard, London',
        address: '32 London Bridge St, London SE1 9SG',
        description: 'Inspiring breakfast event celebrating women leaders in technology.',
        organizer: 'Women in Tech UK',
        attendees: 75,
        maxAttendees: 80,
        price: '£35',
        image: { uri: 'https://via.placeholder.com/300x150/06B6D4/FFFFFF?text=Women+Tech' },
        tags: ['Women in Tech', 'Leadership', 'Breakfast'],
        status: 'upcoming',
        rsvp: false,
        website: 'https://womenintech.co.uk',
        linkedin: 'https://linkedin.com/company/women-in-tech-uk',
      },
      {
        id: 'event_006',
        title: 'DevOps London Meetup',
        type: 'Meetup',
        date: '2025-01-30',
        time: '18:00',
        location: 'Skills Matter',
        address: '10 South Pl, London EC2M 7EB',
        description: 'Monthly DevOps meetup discussing cloud infrastructure and automation.',
        organizer: 'DevOps London',
        attendees: 95,
        maxAttendees: 120,
        price: 'Free',
        image: { uri: 'https://via.placeholder.com/300x150/EF4444/FFFFFF?text=DevOps+Meetup' },
        tags: ['DevOps', 'Cloud', 'Automation'],
        status: 'past',
        rsvp: true,
        website: 'https://devopslondon.com',
        linkedin: 'https://linkedin.com/company/devops-london',
      },
    ];
  },

  async saveContact(contactData) {
    try {
      console.log('💾 Saving contact:', contactData.name);
      
      const key = `contact_${contactData.id}`;
      const dataToSave = {
        ...contactData,
        lastUpdated: new Date().toISOString()
      };
      
      await AsyncStorage.setItem(key, JSON.stringify(dataToSave));
      console.log('✅ Contact saved successfully');
      
      return dataToSave;
      
    } catch (error) {
      console.error('❌ Error saving contact:', error);
      throw error;
    }
  },

  async deleteContact(contactId) {
    try {
      console.log('🗑️ Deleting contact:', contactId);
      
      const key = `contact_${contactId}`;
      await AsyncStorage.removeItem(key);
      
      console.log('✅ Contact deleted successfully');
      
    } catch (error) {
      console.error('❌ Error deleting contact:', error);
      throw error;
    }
  },

  async rsvpEvent(eventId, rsvpStatus) {
    try {
      console.log('📅 RSVP event:', eventId, rsvpStatus);
      
      const key = `event_rsvp_${eventId}`;
      const rsvpData = {
        eventId,
        rsvp: rsvpStatus,
        timestamp: new Date().toISOString()
      };
      
      await AsyncStorage.setItem(key, JSON.stringify(rsvpData));
      console.log('✅ RSVP saved successfully');
      
      return rsvpData;
      
    } catch (error) {
      console.error('❌ Error saving RSVP:', error);
      throw error;
    }
  }
};

import axios from 'axios';
import * as Print from 'expo-print';
import * as Sharing from 'expo-sharing';
import { apiFetch } from '../../utils/apiClient';
import useProfile from '../../hooks/useProfile';
import ProfileManagementService from '../../services/ProfileManagementService';
import PROFILE_KEYS from '../../constants/profileKeys';

// === API CONFIG ===
const API_BASE = 'https://api.jobeng.ai';
const API_KEY = '16a0651c78da416445e9c2946fb72fd9a6e4ce4a71ba610db15251050c3462ef';
const { width: screenWidth } = Dimensions.get('window');
const API_BASE_URL = 'https://api.jobeng.ai';
const api = axios.create({ baseURL: API_BASE_URL, timeout: 15000, headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-API-Key': '16a0651c78da416445e9c2946fb72fd9a6e4ce4a71ba610db15251050c3462ef' } });
api.interceptors.request.use(async c => { try { const t = await AsyncStorage.getItem('auth_token'); if (t) c.headers.Authorization = 'Bearer ' + t; const bid = await AsyncStorage.getItem(`professional_${_profUserId}_company_id`); if (bid) c.params = { ...c.params, company_id: parseInt(bid) }; } catch {} return c; }, e => Promise.reject(e));
const EP = { employees: API_BASE_URL + '/api/data/employees', applications: API_BASE_URL + '/api/data/applications', companyProfile: API_BASE_URL + '/api/data/company_profiles', contacts: API_BASE_URL + '/api/data/crm_contacts' };
const safeData = r => (r?.data?.success && Array.isArray(r.data.data)) ? r.data.data : [];

export default function NetworkingScreen({ navigation, route }) {
  // ── Profile integration (auto-injected) ──
  const profileCtx = useProfile();
  // === Live API Data ===
  const [userId, setUserId] = React.useState('default');
  React.useEffect(() => {
    AsyncStorage.getItem('userToken').then(t => { if (t) setUserId(t.slice(0, 16)); }).catch(() => {});
  }, []);
  React.useEffect(() => {
    if (userId === 'default') return;
    const _ck = `professional_${_profUserId}_networkingscreen`;
    apiFetch('/api/data/customers?sort=created_at&order=desc&limit=30').then(d => {
      if (d && !d.error) {
        const arr = Array.isArray(d) ? d : (d.data || d.results || []);
        AsyncStorage.setItem(_ck, JSON.stringify(arr)).catch(() => {});
      }
    }).catch(() => {});
  }, [userId]);

  // Route params
  const { source = '' } = route?.params || {};
  const jobId = route?.params?.jobId || null;
  const jobTitle = route?.params?.jobTitle || '';
  const [companyLogo, setCompanyLogo] = useState(route?.params?.companyLogo || null);
  const [companyName, setCompanyName] = useState(route?.params?.companyName || '');
  const [companyId, setCompanyId] = useState(null);

  // Main states
  const [activeTab, setActiveTab] = useState('contacts');
  const [searchQuery, setSearchQuery] = useState('');
  const [loading, setLoading] = useState(false);
  const [refreshing, setRefreshing] = useState(false);
  
  // Data states
  const [contacts, setContacts] = useState([]);
  const [events, setEvents] = useState([]);
  const [filteredContacts, setFilteredContacts] = useState([]);
  const [filteredEvents, setFilteredEvents] = useState([]);
  
  // Modal states
  const [showContactModal, setShowContactModal] = useState(false);
  const [showEventModal, setShowEventModal] = useState(false);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [showAddContactModal, setShowAddContactModal] = useState(false);
  
  // Selected items
  const [selectedContact, setSelectedContact] = useState(null);
  const [selectedEvent, setSelectedEvent] = useState(null);
  
  // Filter states
  const [filters, setFilters] = useState({
    industry: 'all',
    location: 'all',
    connectionType: 'all',
    strength: 'all',
    eventType: 'all',
    eventStatus: 'all',
  });
  
  // Messages state
  const [messages, setMessages] = useState([]);
  const [messageText, setMessageText] = useState('');
  const [selectedChatContact, setSelectedChatContact] = useState(null);
  const [showChatModal, setShowChatModal] = useState(false);
  const [whatsappNumber, setWhatsappNumber] = useState('');
  const [whatsappMessage, setWhatsappMessage] = useState('');
  const [messageTemplates] = useState([
    { id: 1, name: 'Introduction', text: 'Hi {name}, I\'m reaching out from {company}. I\'d love to connect and discuss potential opportunities.' },
    { id: 2, name: 'Follow Up', text: 'Hi {name}, it was great meeting you at {event}. I\'d love to continue our conversation.' },
    { id: 3, name: 'Job Opportunity', text: 'Hi {name}, we have an exciting opportunity at {company} that matches your skills. Would you be interested in learning more?' },
    { id: 4, name: 'Interview Invite', text: 'Hi {name}, we\'d like to invite you for an interview at {company}. Please let us know your availability.' },
    { id: 5, name: 'Thank You', text: 'Hi {name}, thank you for your time today. We appreciate your interest in {company}.' },
    { id: 6, name: 'Networking', text: 'Hi {name}, I came across your profile and I\'m impressed by your work in {industry}. Would you be open to a quick chat?' },
  ]);

  // Add contact form
  const [newContact, setNewContact] = useState({
    name: '',
    title: '',
    company: '',
    industry: '',
    location: '',
    email: '',
    phone: '',
    linkedin: '',
    notes: '',
    tags: '',
  });

  // Animation values
  const fadeAnim = useRef(new Animated.Value(0)).current;
  const slideAnim = useRef(new Animated.Value(50)).current;

  // Load data on component mount and focus
  // ── Company Logo ──
  const loadCompanyLogo = async () => {
    try { const cc = await AsyncStorage.getItem('company_profile'); if (cc) { const p = JSON.parse(cc); setCompanyLogo(p.logo || null); if (p.name || p.company_name) setCompanyName(p.name || p.company_name); }
      const cid = await AsyncStorage.getItem(`professional_${_profUserId}_company_id`); if (cid) { setCompanyId(cid);
        try { const r = await api.get(EP.companyProfile, { params: { company_id: cid } }); if (r.data?.success && r.data.data?.length > 0) { const lp = r.data.data[0]; setCompanyLogo(lp.logo || null); if (lp.name || lp.company_name) setCompanyName(lp.name || lp.company_name); } } catch {} }
    } catch {} };

  // ── Load Messages ──
  const loadMessages = async () => { try { const m = await AsyncStorage.getItem(`professional_${_profUserId}_network_messages`); if (m) setMessages(JSON.parse(m)); } catch {} };

  // ── API Load Contacts ──
  const loadAPIContacts = async () => {
    try {
      // SAFETY: do NOT fall back to '1'. With no company context we cannot
      // safely query CRM contacts — leave the existing list (likely a cached
      // copy) untouched rather than fetching another tenant's data.
      const cid = companyId || await AsyncStorage.getItem(`professional_${_profUserId}_company_id`);
      const parsed = cid ? parseInt(cid, 10) : null;
      if (!parsed || parsed <= 0) return;
      const r = await api.get(EP.contacts, { params: { company_id: parsed, limit: 200 } });
      const apiContacts = safeData(r);
      if (apiContacts.length > 0) {
        const mapped = apiContacts.map(c2 => ({ id: c2.id, name: c2.contact_name || c2.name || 'Unknown', title: c2.title || c2.position || '', company: c2.company || '', industry: c2.industry || '', location: c2.location || '', email: c2.email || '', phone: c2.phone || '', linkedin: c2.linkedin || '', notes: c2.notes || '', connectionStrength: 'medium', tags: (c2.tags || '').split(',').filter(Boolean), avatar: { uri: 'https://ui-avatars.com/api/?name=' + encodeURIComponent(c2.contact_name || c2.name || 'U') + '&background=random' } }));
        setContacts(prev => mapped.length > 0 ? mapped : prev);
      }
    } catch {} };

  // ── Messaging Handlers ──
  const handleSendMessage = async (contact, text) => {
    if (!text?.trim()) return;
    const msg = { id: 'msg_' + Date.now(), contact_id: contact?.id, contact_name: contact?.name || 'Unknown', text: text.trim(), sent_at: new Date().toISOString(), type: 'sent', status: 'delivered' };
    const updated = [msg, ...messages]; setMessages(updated); await AsyncStorage.setItem(`professional_${_profUserId}_network_messages`, JSON.stringify(updated));
    setMessageText(''); Alert.alert('Sent', 'Message sent to ' + (contact?.name || 'contact'));
  };

  const handleSendWhatsApp = (contact, message) => {
    const phone = (contact?.phone || whatsappNumber || '').replace(/[^0-9+]/g, '');
    if (!phone) { Alert.alert('Error', 'No phone number available'); return; }
    const text = (message || whatsappMessage || '').replace('{name}', contact?.name || '').replace('{company}', companyName || 'our company').replace('{industry}', contact?.industry || 'your field').replace('{event}', 'our recent event');
    const url = 'https://wa.me/' + phone.replace('+', '') + '?text=' + encodeURIComponent(text);
    Linking.openURL(url).catch(() => Alert.alert('Error', 'Could not open WhatsApp'));
  };

  const handleSendSMS = (contact, message) => {
    const phone = contact?.phone || '';
    if (!phone) { Alert.alert('Error', 'No phone number'); return; }
    const text = (message || '').replace('{name}', contact?.name || '').replace('{company}', companyName || '');
    Linking.openURL('sms:' + phone + '?body=' + encodeURIComponent(text)).catch(() => Alert.alert('Error', 'Could not open SMS'));
  };

  const handleSendEmail = (contact, subject, body) => {
    const email = contact?.email || '';
    if (!email) { Alert.alert('Error', 'No email available'); return; }
    const text = (body || '').replace('{name}', contact?.name || '').replace('{company}', companyName || '');
    Linking.openURL('mailto:' + email + '?subject=' + encodeURIComponent(subject || 'Hello from ' + (companyName || 'us')) + '&body=' + encodeURIComponent(text)).catch(() => Alert.alert('Error', 'Could not open email'));
  };

  const handleCallContact = (contact) => {
    if (!contact?.phone) { Alert.alert('Error', 'No phone number'); return; }
    Linking.openURL('tel:' + contact.phone);
  };

  const handleOpenLinkedIn = (contact) => {
    if (!contact?.linkedin) { Alert.alert('Error', 'No LinkedIn profile'); return; }
    Linking.openURL(contact.linkedin.startsWith('http') ? contact.linkedin : 'https://linkedin.com/in/' + contact.linkedin);
  };

  const openChatWithContact = (contact) => { setSelectedChatContact(contact); setShowChatModal(true); loadMessages(); };

  const handleUseTemplate = (template, contact) => {
    const text = template.text.replace('{name}', contact?.name || 'there').replace('{company}', companyName || 'our company').replace('{industry}', contact?.industry || 'your field').replace('{event}', 'our recent event');
    setMessageText(text);
  };

  useEffect(() => {
    initializeScreen();
    loadCompanyLogo();
    loadAPIContacts();
    loadMessages();
  }, []);

  useFocusEffect(
    React.useCallback(() => {
      console.log('🔄 NetworkingScreen focused - refreshing data');
      loadNetworkingData();
    }, [])
  );

  const initializeScreen = async () => {
    try {
      setLoading(true);
      
      await loadNetworkingData();
      startAnimations();
      
      if (source) {
        console.log(`🔗 Navigated from ${source} to Networking`);
      }
      
    } catch (error) {
      console.error('❌ Error initializing networking screen:', error);
    } finally {
      setLoading(false);
    }
  };

  const loadNetworkingData = async () => {
    try {
      console.log('🔄 Loading networking data...');
      
      // Load contacts and events in parallel
      const [contactData, eventData] = await Promise.all([
        NetworkingService.getAllContacts(),
        NetworkingService.getAllEvents()
      ]);
      
      setContacts(contactData);
      setEvents(eventData);
      setFilteredContacts(contactData);
      setFilteredEvents(eventData);
      
      console.log('✅ Networking data loaded');
      
    } catch (error) {
      console.error('❌ Error loading networking data:', error);
    }
  };

  const startAnimations = () => {
    Animated.parallel([
      Animated.timing(fadeAnim, {
        toValue: 1,
        duration: 800,
        useNativeDriver: true,
      }),
      Animated.timing(slideAnim, {
        toValue: 0,
        duration: 800,
        useNativeDriver: true,
      }),
    ]).start();
  };

  const onRefresh = async () => {
    setRefreshing(true);
    try {
      await loadNetworkingData();
    } catch (error) {
      console.error('❌ Error refreshing:', error);
    } finally {
      setRefreshing(false);
    }
  };

  // Filter contacts and events based on search and filters
  useEffect(() => {
    let filteredContactsData = contacts;
    let filteredEventsData = events;

    // Filter contacts by search query
    if (searchQuery && activeTab === 'contacts') {
      filteredContactsData = filteredContactsData.filter(contact =>
        String(contact.name ?? '').toLowerCase().includes(searchQuery.toLowerCase()) ||
        String(contact.company ?? '').toLowerCase().includes(searchQuery.toLowerCase()) ||
        String(contact.title ?? '').toLowerCase().includes(searchQuery.toLowerCase()) ||
        String(contact.industry ?? '').toLowerCase().includes(searchQuery.toLowerCase())
      );
    }

    // Filter events by search query
    if (searchQuery && activeTab === 'events') {
      filteredEventsData = filteredEventsData.filter(event =>
        String(event.title ?? '').toLowerCase().includes(searchQuery.toLowerCase()) ||
        String(event.type ?? '').toLowerCase().includes(searchQuery.toLowerCase()) ||
        String(event.location ?? '').toLowerCase().includes(searchQuery.toLowerCase()) ||
        String(event.organizer ?? '').toLowerCase().includes(searchQuery.toLowerCase())
      );
    }

    // Apply additional filters
    if (filters.industry !== 'all') {
      filteredContactsData = filteredContactsData.filter(c => c.industry === filters.industry);
    }
    if (filters.connectionType !== 'all') {
      filteredContactsData = filteredContactsData.filter(c => c.connectionType === filters.connectionType);
    }
    if (filters.strength !== 'all') {
      filteredContactsData = filteredContactsData.filter(c => c.strength === filters.strength);
    }
    if (filters.eventType !== 'all') {
      filteredEventsData = filteredEventsData.filter(e => e.type === filters.eventType);
    }
    if (filters.eventStatus !== 'all') {
      filteredEventsData = filteredEventsData.filter(e => e.status === filters.eventStatus);
    }

    setFilteredContacts(filteredContactsData);
    setFilteredEvents(filteredEventsData);
  }, [contacts, events, searchQuery, filters, activeTab]);

  // Contact actions
  const handleContactActions = (contact) => {
    Alert.alert(contact.name || 'Contact', 'Choose action', [
      { text: 'WhatsApp', onPress: () => handleSendWhatsApp(contact, 'Hi ' + (contact.name || '') + '!') },
      { text: 'Message', onPress: () => openChatWithContact(contact) },
      { text: 'Email', onPress: () => handleSendEmail(contact) },
      { text: 'Call', onPress: () => handleCallContact(contact) },
      { text: 'SMS', onPress: () => handleSendSMS(contact, 'Hi ' + (contact.name || '') + ' from ' + (companyName || 'our team')) },
      { text: 'LinkedIn', onPress: () => handleOpenLinkedIn(contact) },
      { text: 'Evaluate', onPress: () => navigation?.navigate('EvaluationAssessmentScreen', { companyLogo, companyName, employeeId: contact.id, employeeName: contact.name }) },
      { text: 'Cancel', style: 'cancel' },
    ]);
  };

  const handleContactPress = (contact) => {
    setSelectedContact(contact);
    setShowContactModal(true);
  };

  const handleAddContact = async () => {
    try {
      if (!newContact.name || !newContact.company) {
        Alert.alert('Missing Information', 'Please provide at least name and company.');
        return;
      }

      const contactData = {
        ...newContact,
        id: `contact_${Date.now()}`,
        connectionDate: new Date().toISOString().split('T')[0],
        avatar: { uri: `https://via.placeholder.com/60/0e4e96/FFFFFF?text=${newContact.name.charAt(0)}` },
        connectionType: 'manual',
        mutualConnections: 0,
        skills: newContact.tags ? newContact.tags.split(',').map(tag => tag.trim()) : [],
        tags: newContact.tags ? newContact.tags.split(',').map(tag => tag.trim()) : [],
        status: 'active',
        strength: 'new',
        lastContact: new Date().toISOString().split('T')[0],
      };

      await NetworkingService.saveContact(contactData);
      
      // Update local state
      const updatedContacts = [...contacts, contactData];
      setContacts(updatedContacts);
      
      // Reset form
      setNewContact({
        name: '',
        title: '',
        company: '',
        industry: '',
        location: '',
        email: '',
        phone: '',
        linkedin: '',
        notes: '',
        tags: '',
      });
      
      setShowAddContactModal(false);
      
      Alert.alert('Success', 'Contact added successfully!');
      
    } catch (error) {
      console.error('❌ Error adding contact:', error);
      Alert.alert('Error', 'Failed to add contact. Please try again.');
    }
  };

  const handleDeleteContact = (contact) => {
    Alert.alert(
      'Delete Contact',
      `Are you sure you want to delete ${contact.name}? This action cannot be undone.`,
      [
        { text: 'Cancel', style: 'cancel' },
        {
          text: 'Delete',
          style: 'destructive',
          onPress: async () => {
            try {
              await NetworkingService.deleteContact(contact.id);
              
              const updatedContacts = contacts.filter(c => c.id !== contact.id);
              setContacts(updatedContacts);
              setShowContactModal(false);
              
              Alert.alert('Deleted', 'Contact has been deleted successfully.');
              
            } catch (error) {
              console.error('❌ Error deleting contact:', error);
              Alert.alert('Error', 'Failed to delete contact. Please try again.');
            }
          }
        }
      ]
    );
  };

  // Event actions
  const handleEventPress = (event) => {
    setSelectedEvent(event);
    setShowEventModal(true);
  };

  const handleRSVP = async (event, rsvpStatus) => {
    try {
      await NetworkingService.rsvpEvent(event.id, rsvpStatus);
      
      // Update local state
      const updatedEvents = events.map(e => 
        e.id === event.id ? { ...e, rsvp: rsvpStatus } : e
      );
      setEvents(updatedEvents);
      
      Alert.alert(
        'RSVP Updated',
        rsvpStatus ? 'You have RSVP\'d to this event!' : 'RSVP cancelled.',
        [{ text: 'OK' }]
      );
      
    } catch (error) {
      console.error('❌ Error updating RSVP:', error);
      Alert.alert('Error', 'Failed to update RSVP. Please try again.');
    }
  };

  // External links
  const openLinkedIn = (url) => {
    if (url) {
      Linking.openURL(url).catch(err => {
        console.error('❌ Error opening LinkedIn:', err);
        Alert.alert('Error', 'Unable to open LinkedIn profile.');
      });
    }
  };

  const openEmail = (email) => {
    if (email) {
      Linking.openURL(`mailto:${email}`).catch(err => {
        console.error('❌ Error opening email:', err);
        Alert.alert('Error', 'Unable to open email client.');
      });
    }
  };

  const openPhone = (phone) => {
    if (phone) {
      Linking.openURL(`tel:${phone}`).catch(err => {
        console.error('❌ Error opening phone:', err);
        Alert.alert('Error', 'Unable to open phone dialer.');
      });
    }
  };

  const openWebsite = (url) => {
    if (url) {
      Linking.openURL(url).catch(err => {
        console.error('❌ Error opening website:', err);
        Alert.alert('Error', 'Unable to open website.');
      });
    }
  };

  // Get connection strength color
  const getStrengthColor = (strength) => {
    switch (strength) {
      case 'strong': return '#10B981';
      case 'medium': return '#F59E0B';
      case 'weak': return '#EF4444';
      case 'new': return '#8B5CF6';
      default: return '#64748B';
    }
  };

  // Get event status color
  const getEventStatusColor = (status) => {
    switch (status) {
      case 'upcoming': return '#10B981';
      case 'past': return '#64748B';
      case 'cancelled': return '#EF4444';
      default: return '#64748B';
    }
  };

  // Render contact item
  const renderContactItem = ({ item }) => (
    <Animated.View
      style={[
        styles.contactItem,
        {
          opacity: fadeAnim,
          transform: [{ translateY: slideAnim }]
        }
      ]}
    >
      <TouchableOpacity
        style={styles.contactContent}
        onPress={() => handleContactPress(item)}
        activeOpacity={0.7}
      >
        <Image source={item.avatar} style={styles.contactAvatar} />
        <View style={styles.contactInfo}>
          <Text style={styles.contactName}>{item.name}</Text>
          <Text style={styles.contactTitle}>{item.title}</Text>
          <Text style={styles.contactCompany}>{item.company}</Text>
          <View style={styles.contactMeta}>
            <View style={[styles.strengthBadge, { backgroundColor: getStrengthColor(item.strength) }]}>
              <Text style={styles.strengthText}>
                {item.strength === 'strong' ? 'Strong' :
                 item.strength === 'medium' ? 'Medium' :
                 item.strength === 'weak' ? 'Weak' :
                 item.strength === 'new' ? 'New' : item.strength}
              </Text>
            </View>
            <Text style={styles.mutualConnections}>{item.mutualConnections} mutual</Text>
          </View>
        </View>
        <View style={styles.contactActions}>
          <TouchableOpacity
            style={styles.actionButton}
            onPress={() => openLinkedIn(item.linkedin)}
          >
            <FontAwesome5 name="linkedin" size={16} color="#0077B5" />
          </TouchableOpacity>
          <TouchableOpacity
            style={styles.actionButton}
            onPress={() => openEmail(item.email)}
          >
            <MaterialIcons name="email" size={16} color="#0e4e96" />
          </TouchableOpacity>
        </View>
      </TouchableOpacity>
    </Animated.View>
  );

  // Render event item
  const renderEventItem = ({ item }) => (
    <Animated.View
      style={[
        styles.eventItem,
        {
          opacity: fadeAnim,
          transform: [{ translateY: slideAnim }]
        }
      ]}
    >
      <TouchableOpacity
        style={styles.eventContent}
        onPress={() => handleEventPress(item)}
        activeOpacity={0.7}
      >
        <Image source={item.image} style={styles.eventImage} />
        <View style={styles.eventInfo}>
          <Text style={styles.eventTitle}>{item.title}</Text>
          <Text style={styles.eventType}>{item.type}</Text>
          <View style={styles.eventDetails}>
            <View style={styles.eventDetailRow}>
              <FontAwesome5 name="calendar-alt" size={12} color="#64748B" />
              <Text style={styles.eventDetailText}>{item.date} at {item.time}</Text>
            </View>
            <View style={styles.eventDetailRow}>
              <Ionicons name="location-outline" size={12} color="#64748B" />
              <Text style={styles.eventDetailText}>{item.location}</Text>
            </View>
            <View style={styles.eventDetailRow}>
              <FontAwesome5 name="users" size={12} color="#64748B" />
              <Text style={styles.eventDetailText}>{item.attendees}/{item.maxAttendees} attending</Text>
            </View>
          </View>
          <View style={styles.eventMeta}>
            <View style={[styles.eventStatusBadge, { backgroundColor: getEventStatusColor(item.status) }]}>
              <Text style={styles.eventStatusText}>
                {item.status === 'upcoming' ? 'Upcoming' :
                 item.status === 'past' ? 'Past' :
                 item.status === 'cancelled' ? 'Cancelled' : item.status}
              </Text>
            </View>
            <Text style={styles.eventPrice}>{item.price}</Text>
          </View>
        </View>
        {item.rsvp && (
          <View style={styles.rsvpBadge}>
            <Ionicons name="checkmark-circle" size={20} color="#10B981" />
          </View>
        )}
      </TouchableOpacity>
    </Animated.View>
  );

  // Render empty state
  const renderEmptyState = () => (
    <View style={styles.emptyState}>
      <MaterialCommunityIcons 
        name={activeTab === 'contacts' ? 'account-group' : 'calendar-clock'} 
        size={80} 
        color="#CBD5E1" 
      />
      <Text style={styles.emptyStateTitle}>
        {activeTab === 'contacts' ? 'No Contacts Found' : 'No Events Found'}
      </Text>
      <Text style={styles.emptyStateMessage}>
        {activeTab === 'contacts' 
          ? 'Start building your professional network by adding contacts.'
          : 'Discover networking events to expand your professional connections.'
        }
      </Text>
      {activeTab === 'contacts' && (
        <TouchableOpacity
          style={styles.emptyStateButton}
          onPress={() => setShowAddContactModal(true)}
        >
          <Text style={styles.emptyStateButtonText}>Add Contact</Text>
        </TouchableOpacity>
      )}
    </View>
  );

  // Render loading state
  if (loading) {
    return (
      <SafeAreaView style={styles.safeArea}>
        <StatusBar barStyle="light-content" backgroundColor="#0e4e96" />
        
        <View style={styles.header}>
          <TouchableOpacity
            style={styles.backButton}
            onPress={() => navigation.goBack()}
          >
            <Ionicons name="arrow-back" size={24} color="#ffffff" />
          </TouchableOpacity>
          {companyLogo ? <Image source={{ uri: companyLogo || undefined }} style={{ width: 24, height: 24, borderRadius: 12, marginRight: 8 }} /> : null}<Text style={styles.headerTitle}>Networking</Text>
          <View style={{ width: 32 }}>{/* Empty view for balance */}</View>
        </View>

        <View style={styles.loadingContainer}>
          <ActivityIndicator size={36} color="#0e4e96" />
          <Text style={styles.loadingText}>Loading networking data...</Text>
        </View>
      </SafeAreaView>
    );
  }


  // ══ MESSAGES TAB ══
  const renderMessagesTab = () => (
    <ScrollView style={{ flex: 1, padding: 16 }}>
      <Text style={{ fontSize: 18, fontWeight: 'bold', color: '#1F2937', marginBottom: 16 }}>Messages</Text>
      {contacts.slice(0, 15).map((contact, i) => (
        <TouchableOpacity key={i} style={{ backgroundColor: '#FFF', padding: 12, borderRadius: 10, borderWidth: 1, borderColor: '#E5E7EB', marginBottom: 8, flexDirection: 'row', alignItems: 'center' }}
          onPress={() => openChatWithContact(contact)}>
          {contact.avatar ? <Image source={contact.avatar} style={{ width: 40, height: 40, borderRadius: 20, marginRight: 10 }} /> : <View style={{ width: 40, height: 40, borderRadius: 20, backgroundColor: '#0e4e96', justifyContent: 'center', alignItems: 'center', marginRight: 10 }}><Text style={{ color: '#FFF', fontWeight: 'bold' }}>{((contact.name || '?')[0] || '').toUpperCase()}</Text></View>}
          <View style={{ flex: 1 }}><Text style={{ fontWeight: '600', color: '#1F2937' }}>{contact.name}</Text>
            <Text style={{ fontSize: 12, color: '#6B7280' }}>{contact.company || contact.title || ''}</Text></View>
          <View style={{ flexDirection: 'row', gap: 6 }}>
            <TouchableOpacity onPress={() => handleSendWhatsApp(contact, 'Hi ' + (contact.name || '') + '!')} style={{ padding: 6 }}><MaterialCommunityIcons name="whatsapp" size={20} color="#25D366" /></TouchableOpacity>
            <TouchableOpacity onPress={() => handleSendEmail(contact)} style={{ padding: 6 }}><MaterialCommunityIcons name="email" size={20} color="#3B82F6" /></TouchableOpacity>
            <TouchableOpacity onPress={() => handleCallContact(contact)} style={{ padding: 6 }}><MaterialCommunityIcons name="phone" size={20} color="#10B981" /></TouchableOpacity>
          </View>
        </TouchableOpacity>))}
      <Text style={{ fontSize: 16, fontWeight: '700', color: '#1F2937', marginTop: 16, marginBottom: 12 }}>Recent Messages ({messages.length})</Text>
      {messages.slice(0, 10).map((msg, i) => (<View key={i} style={{ backgroundColor: msg.type === 'sent' ? '#EFF6FF' : '#FFF', padding: 10, borderRadius: 8, borderWidth: 1, borderColor: '#E5E7EB', marginBottom: 6 }}>
        <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}><Text style={{ fontWeight: '600', color: '#1F2937', fontSize: 13 }}>{msg.contact_name || 'Unknown'}</Text>
          <Text style={{ fontSize: 10, color: '#9CA3AF' }}>{new Date(msg.sent_at).toLocaleDateString('en-GB')}</Text></View>
        <Text style={{ fontSize: 12, color: '#4B5563', marginTop: 2 }}>{(msg.text || '').substring(0, 80)}</Text></View>))}
    </ScrollView>
  );

  // ══ WHATSAPP TAB ══
  const renderWhatsAppTab = () => (
    <KeyboardAvoidingView behavior={Platform.OS === 'ios' ? 'padding' : 'height'} style={{ flex: 1 }}>
      <ScrollView style={{ padding: 16 }}>
        <Text style={{ fontSize: 18, fontWeight: 'bold', color: '#25D366', marginBottom: 16 }}>WhatsApp Messaging</Text>
        {/* Quick Send */}
        <View style={{ backgroundColor: '#FFF', padding: 14, borderRadius: 12, borderWidth: 1, borderColor: '#E5E7EB', marginBottom: 16 }}>
          <Text style={{ fontSize: 14, fontWeight: '600', color: '#1F2937', marginBottom: 8 }}>Quick WhatsApp Message</Text>
          <View style={{ marginBottom: 10 }}><Text style={{ fontSize: 12, fontWeight: '600', color: '#374151', marginBottom: 4 }}>Phone Number</Text>
            <TextInput style={{ backgroundColor: '#F3F4F6', borderRadius: 8, padding: 10, fontSize: 14, color: '#1F2937', borderWidth: 1, borderColor: '#E5E7EB' }} placeholder="+44 7123 456789" value={whatsappNumber} onChangeText={setWhatsappNumber} keyboardType="phone-pad" /></View>
          <View style={{ marginBottom: 10 }}><Text style={{ fontSize: 12, fontWeight: '600', color: '#374151', marginBottom: 4 }}>Message</Text>
            <TextInput style={{ backgroundColor: '#F3F4F6', borderRadius: 8, padding: 10, fontSize: 14, color: '#1F2937', borderWidth: 1, borderColor: '#E5E7EB', height: 80, textAlignVertical: 'top' }} placeholder="Type your message..." value={whatsappMessage} onChangeText={setWhatsappMessage} multiline /></View>
          <TouchableOpacity style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'center', backgroundColor: '#25D366', borderRadius: 10, padding: 14 }}
            onPress={() => handleSendWhatsApp({ phone: whatsappNumber }, whatsappMessage)}>
            <MaterialCommunityIcons name="whatsapp" size={20} color="#FFF" /><Text style={{ color: '#FFF', fontWeight: '700', fontSize: 15, marginLeft: 8 }}>Send via WhatsApp</Text></TouchableOpacity>
        </View>
        {/* Templates */}
        <Text style={{ fontSize: 16, fontWeight: '700', color: '#1F2937', marginBottom: 12 }}>Message Templates</Text>
        {messageTemplates.map((tmpl, i) => (<TouchableOpacity key={i} style={{ backgroundColor: '#FFF', padding: 12, borderRadius: 8, borderWidth: 1, borderColor: '#E5E7EB', marginBottom: 6 }}
          onPress={() => setWhatsappMessage(tmpl.text.replace('{company}', companyName || 'our company'))}>
          <Text style={{ fontWeight: '600', color: '#1F2937' }}>{tmpl.name}</Text>
          <Text style={{ fontSize: 12, color: '#6B7280', marginTop: 2 }}>{tmpl.text.substring(0, 80)}...</Text></TouchableOpacity>))}
        {/* Contact Quick Send */}
        <Text style={{ fontSize: 16, fontWeight: '700', color: '#1F2937', marginTop: 16, marginBottom: 12 }}>Send to Contact</Text>
        {contacts.filter(c2 => c2.phone).slice(0, 10).map((contact, i) => (
          <TouchableOpacity key={i} style={{ backgroundColor: '#FFF', padding: 10, borderRadius: 8, borderWidth: 1, borderColor: '#E5E7EB', marginBottom: 6, flexDirection: 'row', alignItems: 'center' }}
            onPress={() => handleSendWhatsApp(contact, whatsappMessage || 'Hi ' + (contact.name || '') + '!')}>
            <MaterialCommunityIcons name="whatsapp" size={22} color="#25D366" style={{ marginRight: 10 }} />
            <View style={{ flex: 1 }}><Text style={{ fontWeight: '600', color: '#1F2937' }}>{contact.name}</Text><Text style={{ fontSize: 11, color: '#6B7280' }}>{contact.phone}</Text></View>
            <MaterialCommunityIcons name="send" size={18} color="#25D366" /></TouchableOpacity>))}
        <View style={{ height: 40 }} />
      </ScrollView>
    </KeyboardAvoidingView>
  );

  // ══ GROUPS TAB ══
  const renderGroupsTab = () => (
    <ScrollView style={{ flex: 1, padding: 16 }}>
      <Text style={{ fontSize: 18, fontWeight: 'bold', color: '#1F2937', marginBottom: 16 }}>Contact Groups</Text>
      {Object.entries(contacts.reduce((acc, c2) => { const ind = c2.industry || 'Other'; acc[ind] = (acc[ind] || []); acc[ind].push(c2); return acc; }, {})).sort((a, b) => b[1].length - a[1].length).map(([industry, members], i) => (
        <View key={i} style={{ backgroundColor: '#FFF', padding: 14, borderRadius: 10, borderWidth: 1, borderColor: '#E5E7EB', marginBottom: 8 }}>
          <View style={{ flexDirection: 'row', justifyContent: 'space-between', marginBottom: 8 }}><Text style={{ fontWeight: '700', color: '#1F2937' }}>{industry}</Text>
            <Text style={{ fontSize: 12, fontWeight: '600', color: '#0e4e96' }}>{members.length} contacts</Text></View>
          {members.slice(0, 3).map((m, j) => (<Text key={j} style={{ fontSize: 12, color: '#6B7280' }}>{m.name}{m.company ? ' · ' + m.company : ''}</Text>))}
          <View style={{ flexDirection: 'row', gap: 6, marginTop: 8 }}>
            <TouchableOpacity style={{ flex: 1, flexDirection: 'row', alignItems: 'center', justifyContent: 'center', backgroundColor: '#25D36615', paddingVertical: 8, borderRadius: 8 }}
              onPress={() => { members.slice(0, 5).forEach(m => { if (m.phone) handleSendWhatsApp(m, 'Hi ' + (m.name || '') + '!'); }); Alert.alert('Sent', 'WhatsApp messages sent to group'); }}>
              <MaterialCommunityIcons name="whatsapp" size={14} color="#25D366" /><Text style={{ marginLeft: 4, fontSize: 11, fontWeight: '600', color: '#25D366' }}>WhatsApp All</Text></TouchableOpacity>
            <TouchableOpacity style={{ flex: 1, flexDirection: 'row', alignItems: 'center', justifyContent: 'center', backgroundColor: '#3B82F615', paddingVertical: 8, borderRadius: 8 }}
              onPress={() => { members.filter(m => m.email).slice(0, 5).forEach(m => handleSendEmail(m)); }}>
              <MaterialCommunityIcons name="email" size={14} color="#3B82F6" /><Text style={{ marginLeft: 4, fontSize: 11, fontWeight: '600', color: '#3B82F6' }}>Email All</Text></TouchableOpacity>
          </View>
        </View>))}
    </ScrollView>
  );

  // ══ CHAT MODAL ══
  const renderChatModal = () => (<Modal visible={showChatModal} animationType="slide" presentationStyle="pageSheet" onRequestClose={() => setShowChatModal(false)}>
    <SafeAreaView style={{ flex: 1, backgroundColor: '#FFF' }}>
      <View style={{ flexDirection: 'row', alignItems: 'center', padding: 16, borderBottomWidth: 1, borderBottomColor: '#E5E7EB' }}>
        <TouchableOpacity onPress={() => setShowChatModal(false)}><MaterialCommunityIcons name="arrow-left" size={24} color="#1F2937" /></TouchableOpacity>
        <View style={{ flex: 1, marginLeft: 12 }}><Text style={{ fontSize: 16, fontWeight: '700', color: '#1F2937' }}>{selectedChatContact?.name || 'Chat'}</Text>
          <Text style={{ fontSize: 12, color: '#6B7280' }}>{selectedChatContact?.company || ''}</Text></View>
        <TouchableOpacity onPress={() => handleSendWhatsApp(selectedChatContact, '')} style={{ marginRight: 8 }}><MaterialCommunityIcons name="whatsapp" size={22} color="#25D366" /></TouchableOpacity>
        <TouchableOpacity onPress={() => handleCallContact(selectedChatContact)}><MaterialCommunityIcons name="phone" size={22} color="#10B981" /></TouchableOpacity></View>
      <ScrollView style={{ flex: 1, padding: 16 }}>
        {messages.filter(m => m.contact_id === selectedChatContact?.id).slice(0, 20).map((msg, i) => (
          <View key={i} style={{ alignSelf: msg.type === 'sent' ? 'flex-end' : 'flex-start', backgroundColor: msg.type === 'sent' ? '#0e4e96' : '#F3F4F6', padding: 10, borderRadius: 12, marginBottom: 6, maxWidth: '80%' }}>
            <Text style={{ color: msg.type === 'sent' ? '#FFF' : '#1F2937', fontSize: 14 }}>{msg.text}</Text>
            <Text style={{ fontSize: 10, color: msg.type === 'sent' ? '#93C5FD' : '#9CA3AF', marginTop: 2, textAlign: 'right' }}>{new Date(msg.sent_at).toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' })}</Text></View>))}
        <Text style={{ fontSize: 13, fontWeight: '600', color: '#374151', marginTop: 16, marginBottom: 8 }}>Quick Templates</Text>
        <ScrollView horizontal showsHorizontalScrollIndicator={false}>{messageTemplates.map((tmpl, i) => (
          <TouchableOpacity key={i} style={{ backgroundColor: '#EFF6FF', paddingHorizontal: 12, paddingVertical: 6, borderRadius: 16, marginRight: 8 }}
            onPress={() => handleUseTemplate(tmpl, selectedChatContact)}><Text style={{ fontSize: 11, color: '#0e4e96', fontWeight: '600' }}>{tmpl.name}</Text></TouchableOpacity>))}</ScrollView>
      </ScrollView>
      <View style={{ flexDirection: 'row', alignItems: 'center', padding: 12, borderTopWidth: 1, borderTopColor: '#E5E7EB' }}>
        <TextInput style={{ flex: 1, backgroundColor: '#F3F4F6', borderRadius: 20, paddingHorizontal: 16, paddingVertical: 10, fontSize: 14, color: '#1F2937', marginRight: 8 }} placeholder="Type a message..." value={messageText} onChangeText={setMessageText} />
        <TouchableOpacity style={{ width: 40, height: 40, borderRadius: 20, backgroundColor: '#0e4e96', justifyContent: 'center', alignItems: 'center' }}
          onPress={() => handleSendMessage(selectedChatContact, messageText)}><MaterialCommunityIcons name="send" size={18} color="#FFF" /></TouchableOpacity>
        <TouchableOpacity style={{ width: 40, height: 40, borderRadius: 20, backgroundColor: '#25D366', justifyContent: 'center', alignItems: 'center', marginLeft: 6 }}
          onPress={() => handleSendWhatsApp(selectedChatContact, messageText)}><MaterialCommunityIcons name="whatsapp" size={18} color="#FFF" /></TouchableOpacity>
      </View>
    </SafeAreaView>
  </Modal>);

  return (
    <SafeAreaView style={styles.safeArea}>
      <StatusBar barStyle="light-content" backgroundColor="#0e4e96" />

      {/* Header */}
      <View style={styles.header}>
        <TouchableOpacity
          style={styles.backButton}
          onPress={() => navigation.goBack()}
        >
          <Ionicons name="arrow-back" size={24} color="#ffffff" />
        </TouchableOpacity>
        {companyLogo ? <Image source={{ uri: companyLogo || undefined }} style={{ width: 24, height: 24, borderRadius: 12, marginRight: 8 }} /> : null}<Text style={styles.headerTitle}>Networking</Text>
        <View style={styles.headerActions}>
          <TouchableOpacity
            style={styles.headerAction}
            onPress={() => setShowFilterModal(true)}
          >
            <MaterialIcons name="filter-list" size={24} color="#ffffff" />
          </TouchableOpacity>
          {activeTab === 'contacts' && (
            <TouchableOpacity
              style={styles.headerAction}
              onPress={() => setShowAddContactModal(true)}
            >
              <MaterialIcons name="person-add" size={24} color="#ffffff" />
            </TouchableOpacity>
          )}
        </View>
      </View>

      {/* Source indicator */}
      {source && (
        <View style={styles.sourceIndicator}>
          <Ionicons name="information-circle-outline" size={16} color="#007AFF" />
          <Text style={styles.sourceText}>From {source}</Text>
        </View>
      )}

      {/* Statistics Cards */}
      <ScrollView
        horizontal
        showsHorizontalScrollIndicator={false}
        style={styles.statsScrollView}
        contentContainerStyle={styles.statsContainer}
      >
        <View key="contacts" style={styles.statCard}>
          <Text style={styles.statNumber}>{contacts.length}</Text>
          <Text style={styles.statLabel}>Contacts</Text>
        </View>
        <View key="events" style={styles.statCard}>
          <Text style={styles.statNumber}>{events.filter(e => e.status === 'upcoming').length}</Text>
          <Text style={styles.statLabel}>Upcoming Events</Text>
        </View>
        <View key="rsvp" style={styles.statCard}>
          <Text style={styles.statNumber}>{events.filter(e => e.rsvp).length}</Text>
          <Text style={styles.statLabel}>RSVP'd</Text>
        </View>
        <View key="strong" style={styles.statCard}>
          <Text style={styles.statNumber}>{contacts.filter(c => c.strength === 'strong').length}</Text>
          <Text style={styles.statLabel}>Strong Connections</Text>
        </View>
      </ScrollView>

      {/* Search Bar */}
      <View style={styles.searchContainer}>
        <View style={styles.searchBar}>
          <Ionicons name="search" size={20} color="#64748B" />
          <TextInput
            style={styles.searchInput}
            placeholder={`Search ${activeTab}...`}
            placeholderTextColor="#94A3B8"
            value={searchQuery}
            onChangeText={setSearchQuery}
          />
          {searchQuery.length > 0 && (
            <TouchableOpacity onPress={() => setSearchQuery('')}>
              <Ionicons name="close-circle" size={20} color="#64748B" />
            </TouchableOpacity>
          )}
        </View>
      </View>

      {/* Tab Navigation */}
      <ScrollView horizontal showsHorizontalScrollIndicator={false} style={{ backgroundColor: '#FFF', borderBottomWidth: 1, borderBottomColor: '#E5E7EB', paddingVertical: 4, flexGrow: 0, flexShrink: 0, maxHeight: 38 }} contentContainerStyle={{ paddingHorizontal: 10, gap: 6, alignItems: 'center' }}>
        {[{ k: 'contacts', t: 'Contacts', i: 'account-group', c: '#0e4e96' }, { k: 'events', t: 'Events', i: 'calendar', c: '#8B5CF6' }, { k: 'messages', t: 'Messages', i: 'message-text', c: '#3B82F6' }, { k: 'whatsapp', t: 'WhatsApp', i: 'whatsapp', c: '#25D366' }, { k: 'groups', t: 'Groups', i: 'account-multiple', c: '#F59E0B' }].map(tab => (
          <TouchableOpacity key={tab.k} style={{ flexDirection: 'row', alignItems: 'center', paddingHorizontal: 12, paddingVertical: 6, borderRadius: 16, backgroundColor: activeTab === tab.k ? tab.c + '15' : '#F8FAFC', borderWidth: 1, borderColor: activeTab === tab.k ? tab.c : '#E2E8F0' }}
            onPress={() => setActiveTab(tab.k)}>
            <MaterialCommunityIcons name={tab.i} size={14} color={activeTab === tab.k ? tab.c : '#94A3B8'} />
            <Text style={{ marginLeft: 4, fontSize: 11, fontWeight: '600', color: activeTab === tab.k ? tab.c : '#94A3B8' }}>{tab.t}</Text></TouchableOpacity>))}
      </ScrollView>

      {/* Content */}
      {activeTab === 'messages' ? renderMessagesTab() :
       activeTab === 'whatsapp' ? renderWhatsAppTab() :
       activeTab === 'groups' ? renderGroupsTab() : (
      <FlatList
        data={activeTab === 'contacts' ? filteredContacts : filteredEvents}
        renderItem={activeTab === 'contacts' ? renderContactItem : renderEventItem}
        keyExtractor={(item, index) => item.id ? item.id.toString() : `${activeTab}-${index}`}
        contentContainerStyle={styles.listContainer}
        showsVerticalScrollIndicator={false}
        refreshControl={
          <RefreshControl
            refreshing={refreshing}
            onRefresh={onRefresh}
            colors={['#0e4e96']}
            tintColor="#0e4e96"
          />
        }
        ListEmptyComponent={renderEmptyState}
      />
      )}

      {/* Contact Detail Modal */}
      <Modal
        visible={showContactModal}
        transparent={true}
        animationType="slide"
        onRequestClose={() => setShowContactModal(false)}
      >
        <View style={styles.modalContainer}>
          <View style={styles.contactModalContent}>
            {selectedContact && (
              <>
                <View style={styles.modalHeader}>
                  <Text style={styles.modalTitle}>Contact Details</Text>
                  <TouchableOpacity onPress={() => setShowContactModal(false)}>
                    <Ionicons name="close" size={24} color="#64748B" />
                  </TouchableOpacity>
                </View>

                <ScrollView style={styles.contactDetails}>
                  {/* Contact Header */}
                  <View style={styles.contactDetailHeader}>
                    <Image source={selectedContact.avatar} style={styles.contactDetailAvatar} />
                    <View style={styles.contactDetailInfo}>
                      <Text style={styles.contactDetailName}>{selectedContact.name}</Text>
                      <Text style={styles.contactDetailTitle}>{selectedContact.title}</Text>
                      <Text style={styles.contactDetailCompany}>{selectedContact.company}</Text>
                      <View style={styles.contactDetailMeta}>
                        <View style={[styles.strengthBadge, { backgroundColor: getStrengthColor(selectedContact.strength) }]}>
                          <Text style={styles.strengthText}>
                            {selectedContact.strength === 'strong' ? 'Strong Connection' :
                             selectedContact.strength === 'medium' ? 'Medium Connection' :
                             selectedContact.strength === 'weak' ? 'Weak Connection' :
                             selectedContact.strength === 'new' ? 'New Connection' : selectedContact.strength}
                          </Text>
                        </View>
                      </View>
                    </View>
                  </View>

                  {/* Contact Information */}
                  <View style={styles.contactSection}>
                    <Text style={styles.contactSectionTitle}>Contact Information</Text>
                    
                    {selectedContact.email && (
                      <TouchableOpacity
                        style={styles.contactDetailRow}
                        onPress={() => openEmail(selectedContact.email)}
                      >
                        <MaterialIcons name="email" size={20} color="#0e4e96" />
                        <Text style={styles.contactDetailText}>{selectedContact.email}</Text>
                        <Ionicons name="open-outline" size={16} color="#64748B" />
                      </TouchableOpacity>
                    )}
                    
                    {selectedContact.phone && (
                      <TouchableOpacity
                        style={styles.contactDetailRow}
                        onPress={() => openPhone(selectedContact.phone)}
                      >
                        <MaterialIcons name="phone" size={20} color="#0e4e96" />
                        <Text style={styles.contactDetailText}>{selectedContact.phone}</Text>
                        <Ionicons name="open-outline" size={16} color="#64748B" />
                      </TouchableOpacity>
                    )}
                    
                    {selectedContact.linkedin && (
                      <TouchableOpacity
                        style={styles.contactDetailRow}
                        onPress={() => openLinkedIn(selectedContact.linkedin)}
                      >
                        <FontAwesome5 name="linkedin" size={20} color="#0077B5" />
                        <Text style={styles.contactDetailText}>LinkedIn Profile</Text>
                        <Ionicons name="open-outline" size={16} color="#64748B" />
                      </TouchableOpacity>
                    )}
                    
                    <View style={styles.contactDetailRow}>
                      <Ionicons name="location-outline" size={20} color="#64748B" />
                      <Text style={styles.contactDetailText}>{selectedContact.location}</Text>
                    </View>
                    
                    <View style={styles.contactDetailRow}>
                      <MaterialIcons name="business" size={20} color="#64748B" />
                      <Text style={styles.contactDetailText}>{selectedContact.industry}</Text>
                    </View>
                  </View>

                  {/* Connection Details */}
                  <View style={styles.contactSection}>
                    <Text style={styles.contactSectionTitle}>Connection Details</Text>
                    
                    <View style={styles.contactDetailRow}>
                      <MaterialIcons name="link" size={20} color="#64748B" />
                      <Text style={styles.contactDetailText}>
                        Connected via {selectedContact.connectionType} on {selectedContact.connectionDate}
                      </Text>
                    </View>
                    
                    <View style={styles.contactDetailRow}>
                      <FontAwesome5 name="users" size={20} color="#64748B" />
                      <Text style={styles.contactDetailText}>
                        {selectedContact.mutualConnections} mutual connections
                      </Text>
                    </View>
                    
                    {selectedContact.lastContact && (
                      <View style={styles.contactDetailRow}>
                        <MaterialIcons name="schedule" size={20} color="#64748B" />
                        <Text style={styles.contactDetailText}>
                          Last contact: {selectedContact.lastContact}
                        </Text>
                      </View>
                    )}
                  </View>

                  {/* Skills */}
                  {selectedContact.skills && selectedContact.skills.length > 0 && (
                    <View style={styles.contactSection}>
                      <Text style={styles.contactSectionTitle}>Skills</Text>
                      <View style={styles.skillsContainer}>
                        {selectedContact.skills.map((skill, index) => (
                          <View key={index} style={styles.skillTag}>
                            <Text style={styles.skillTagText}>{skill}</Text>
                          </View>
                        ))}
                      </View>
                    </View>
                  )}

                  {/* Bio */}
                  {selectedContact.bio && (
                    <View style={styles.contactSection}>
                      <Text style={styles.contactSectionTitle}>About</Text>
                      <Text style={styles.contactBio}>{selectedContact.bio}</Text>
                    </View>
                  )}

                  {/* Notes */}
                  {selectedContact.notes && (
                    <View style={styles.contactSection}>
                      <Text style={styles.contactSectionTitle}>Notes</Text>
                      <Text style={styles.contactNotes}>{selectedContact.notes}</Text>
                    </View>
                  )}

                  {/* Tags */}
                  {selectedContact.tags && selectedContact.tags.length > 0 && (
                    <View style={styles.contactSection}>
                      <Text style={styles.contactSectionTitle}>Tags</Text>
                      <View style={styles.tagsContainer}>
                        {selectedContact.tags.map((tag, index) => (
                          <View key={index} style={styles.tag}>
                            <Text style={styles.tagText}>{tag}</Text>
                          </View>
                        ))}
                      </View>
                    </View>
                  )}
                </ScrollView>

                <View style={styles.contactModalActions}>
                  <TouchableOpacity
                    style={styles.deleteContactButton}
                    onPress={() => handleDeleteContact(selectedContact)}
                  >
                    <MaterialIcons name="delete-outline" size={20} color="#EF4444" />
                    <Text style={styles.deleteContactText}>Delete Contact</Text>
                  </TouchableOpacity>
                </View>
              </>
            )}
          </View>
        </View>
      </Modal>

      {/* Event Detail Modal */}
      <Modal
        visible={showEventModal}
        transparent={true}
        animationType="slide"
        onRequestClose={() => setShowEventModal(false)}
      >
        <View style={styles.modalContainer}>
          <View style={styles.eventModalContent}>
            {selectedEvent && (
              <>
                <View style={styles.modalHeader}>
                  <Text style={styles.modalTitle}>Event Details</Text>
                  <TouchableOpacity onPress={() => setShowEventModal(false)}>
                    <Ionicons name="close" size={24} color="#64748B" />
                  </TouchableOpacity>
                </View>

                <ScrollView style={styles.eventDetails}>
                  {/* Event Header */}
                  <Image source={selectedEvent.image} style={styles.eventDetailImage} />
                  
                  <View style={styles.eventDetailHeader}>
                    <Text style={styles.eventDetailTitle}>{selectedEvent.title}</Text>
                    <Text style={styles.eventDetailType}>{selectedEvent.type}</Text>
                    <Text style={styles.eventDetailOrganizer}>by {selectedEvent.organizer}</Text>
                  </View>

                  {/* Event Information */}
                  <View style={styles.eventSection}>
                    <Text style={styles.eventSectionTitle}>Event Information</Text>
                    
                    <View style={styles.eventDetailRow}>
                      <FontAwesome5 name="calendar-alt" size={20} color="#0e4e96" />
                      <Text style={styles.eventDetailText}>{selectedEvent.date} at {selectedEvent.time}</Text>
                    </View>
                    
                    <View style={styles.eventDetailRow}>
                      <Ionicons name="location-outline" size={20} color="#0e4e96" />
                      <View style={styles.eventLocationInfo}>
                        <Text style={styles.eventDetailText}>{selectedEvent.location}</Text>
                        <Text style={styles.eventAddress}>{selectedEvent.address}</Text>
                      </View>
                    </View>
                    
                    <View style={styles.eventDetailRow}>
                      <FontAwesome5 name="users" size={20} color="#0e4e96" />
                      <Text style={styles.eventDetailText}>
                        {selectedEvent.attendees} of {selectedEvent.maxAttendees} attending
                      </Text>
                    </View>
                    
                    <View style={styles.eventDetailRow}>
                      <MaterialIcons name="attach-money" size={20} color="#0e4e96" />
                      <Text style={styles.eventDetailText}>{selectedEvent.price}</Text>
                    </View>
                  </View>

                  {/* Description */}
                  <View style={styles.eventSection}>
                    <Text style={styles.eventSectionTitle}>Description</Text>
                    <Text style={styles.eventDescription}>{selectedEvent.description}</Text>
                  </View>

                  {/* Tags */}
                  {selectedEvent.tags && selectedEvent.tags.length > 0 && (
                    <View style={styles.eventSection}>
                      <Text style={styles.eventSectionTitle}>Topics</Text>
                      <View style={styles.eventTagsContainer}>
                        {selectedEvent.tags.map((tag, index) => (
                          <View key={index} style={styles.eventTag}>
                            <Text style={styles.eventTagText}>{tag}</Text>
                          </View>
                        ))}
                      </View>
                    </View>
                  )}

                  {/* Links */}
                  <View style={styles.eventSection}>
                    <Text style={styles.eventSectionTitle}>Links</Text>
                    
                    {selectedEvent.website && (
                      <TouchableOpacity
                        style={styles.eventDetailRow}
                        onPress={() => openWebsite(selectedEvent.website)}
                      >
                        <MaterialIcons name="language" size={20} color="#0e4e96" />
                        <Text style={styles.eventDetailText}>Event Website</Text>
                        <Ionicons name="open-outline" size={16} color="#64748B" />
                      </TouchableOpacity>
                    )}
                    
                    {selectedEvent.linkedin && (
                      <TouchableOpacity
                        style={styles.eventDetailRow}
                        onPress={() => openLinkedIn(selectedEvent.linkedin)}
                      >
                        <FontAwesome5 name="linkedin" size={20} color="#0077B5" />
                        <Text style={styles.eventDetailText}>LinkedIn Page</Text>
                        <Ionicons name="open-outline" size={16} color="#64748B" />
                      </TouchableOpacity>
                    )}
                  </View>
                </ScrollView>

                {/* RSVP Actions */}
                {selectedEvent.status === 'upcoming' && (
                  <View style={styles.eventModalActions}>
                    <TouchableOpacity
                      style={[
                        styles.rsvpButton,
                        selectedEvent.rsvp ? styles.rsvpButtonActive : styles.rsvpButtonInactive
                      ]}
                      onPress={() => handleRSVP(selectedEvent, !selectedEvent.rsvp)}
                    >
                      <Ionicons 
                        name={selectedEvent.rsvp ? "checkmark-circle" : "add-circle-outline"} 
                        size={20} 
                        color={selectedEvent.rsvp ? "#ffffff" : "#0e4e96"} 
                      />
                      <Text style={[
                        styles.rsvpButtonText,
                        selectedEvent.rsvp ? styles.rsvpButtonTextActive : styles.rsvpButtonTextInactive
                      ]}>
                        {selectedEvent.rsvp ? 'Cancel RSVP' : 'RSVP to Event'}
                      </Text>
                    </TouchableOpacity>
                  </View>
                )}
              </>
            )}
          </View>
        </View>
      </Modal>

      {/* Add Contact Modal */}
      <Modal
        visible={showAddContactModal}
        transparent={true}
        animationType="slide"
        onRequestClose={() => setShowAddContactModal(false)}
      >
        <View style={styles.modalContainer}>
          <View style={styles.addContactModalContent}>
            <View style={styles.modalHeader}>
              <Text style={styles.modalTitle}>Add New Contact</Text>
              <TouchableOpacity onPress={() => setShowAddContactModal(false)}>
                <Ionicons name="close" size={24} color="#64748B" />
              </TouchableOpacity>
            </View>

            <ScrollView style={styles.addContactForm}>
              <View style={styles.formSection}>
                <Text style={styles.formLabel}>Name *</Text>
                <TextInput
                  style={styles.formInput}
                  placeholder="Enter full name"
                  placeholderTextColor="#94A3B8"
                  value={newContact.name}
                  onChangeText={text => setNewContact(prev => ({ ...prev, name: text }))}
                />
              </View>

              <View style={styles.formSection}>
                <Text style={styles.formLabel}>Job Title</Text>
                <TextInput
                  style={styles.formInput}
                  placeholder="e.g. Senior Software Engineer"
                  placeholderTextColor="#94A3B8"
                  value={newContact.title}
                  onChangeText={text => setNewContact(prev => ({ ...prev, title: text }))}
                />
              </View>

              <View style={styles.formSection}>
                <Text style={styles.formLabel}>Company *</Text>
                <TextInput
                  style={styles.formInput}
                  placeholder="Company name"
                  placeholderTextColor="#94A3B8"
                  value={newContact.company}
                  onChangeText={text => setNewContact(prev => ({ ...prev, company: text }))}
                />
              </View>

              <View style={styles.formSection}>
                <Text style={styles.formLabel}>Industry</Text>
                <TextInput
                  style={styles.formInput}
                  placeholder="e.g. Technology, Finance, Healthcare"
                  placeholderTextColor="#94A3B8"
                  value={newContact.industry}
                  onChangeText={text => setNewContact(prev => ({ ...prev, industry: text }))}
                />
              </View>

              <View style={styles.formSection}>
                <Text style={styles.formLabel}>Location</Text>
                <TextInput
                  style={styles.formInput}
                  placeholder="e.g. London, UK"
                  placeholderTextColor="#94A3B8"
                  value={newContact.location}
                  onChangeText={text => setNewContact(prev => ({ ...prev, location: text }))}
                />
              </View>

              <View style={styles.formSection}>
                <Text style={styles.formLabel}>Email</Text>
                <TextInput
                  style={styles.formInput}
                  placeholder="email@company.com"
                  placeholderTextColor="#94A3B8"
                  keyboardType="email-address"
                  autoCapitalize="none"
                  value={newContact.email}
                  onChangeText={text => setNewContact(prev => ({ ...prev, email: text }))}
                />
              </View>

              <View style={styles.formSection}>
                <Text style={styles.formLabel}>Phone</Text>
                <TextInput
                  style={styles.formInput}
                  placeholder="+44 20 1234 5678"
                  placeholderTextColor="#94A3B8"
                  keyboardType="phone-pad"
                  value={newContact.phone}
                  onChangeText={text => setNewContact(prev => ({ ...prev, phone: text }))}
                />
              </View>

              <View style={styles.formSection}>
                <Text style={styles.formLabel}>LinkedIn URL</Text>
                <TextInput
                  style={styles.formInput}
                  placeholder="https://linkedin.com/in/username"
                  placeholderTextColor="#94A3B8"
                  autoCapitalize="none"
                  value={newContact.linkedin}
                  onChangeText={text => setNewContact(prev => ({ ...prev, linkedin: text }))}
                />
              </View>

              <View style={styles.formSection}>
                <Text style={styles.formLabel}>Tags</Text>
                <TextInput
                  style={styles.formInput}
                  placeholder="e.g. Frontend, React, Mentor (comma separated)"
                  placeholderTextColor="#94A3B8"
                  value={newContact.tags}
                  onChangeText={text => setNewContact(prev => ({ ...prev, tags: text }))}
                />
              </View>

              <View style={styles.formSection}>
                <Text style={styles.formLabel}>Notes</Text>
                <TextInput
                  style={[styles.formInput, styles.formTextArea]}
                  placeholder="Add any notes about this contact..."
                  placeholderTextColor="#94A3B8"
                  multiline
                  numberOfLines={4}
                  textAlignVertical="top"
                  value={newContact.notes}
                  onChangeText={text => setNewContact(prev => ({ ...prev, notes: text }))}
                />
              </View>
            </ScrollView>

            <View style={styles.addContactActions}>
              <TouchableOpacity
                style={styles.cancelButton}
                onPress={() => setShowAddContactModal(false)}
              >
                <Text style={styles.cancelButtonText}>Cancel</Text>
              </TouchableOpacity>
              <TouchableOpacity
                style={styles.addButton}
                onPress={handleAddContact}
              >
                <Text style={styles.addButtonText}>Add Contact</Text>
              </TouchableOpacity>
            </View>
          </View>
        </View>
      </Modal>

      {/* Filter Modal */}
      <Modal
        visible={showFilterModal}
        transparent={true}
        animationType="slide"
        onRequestClose={() => setShowFilterModal(false)}
      >
        <View style={styles.modalContainer}>
          <View style={styles.filterModalContent}>
            <View style={styles.modalHeader}>
              <Text style={styles.modalTitle}>Filter {activeTab === 'contacts' ? 'Contacts' : 'Events'}</Text>
              <TouchableOpacity onPress={() => setShowFilterModal(false)}>
                <Ionicons name="close" size={24} color="#64748B" />
              </TouchableOpacity>
            </View>

            <ScrollView style={styles.filterContent}>
              {activeTab === 'contacts' ? (
                <>
                  {/* Industry Filter */}
                  <View style={styles.filterSection}>
                    <Text style={styles.filterSectionTitle}>Industry</Text>
                    <View style={styles.filterOptions}>
                      {['all', 'Technology', 'Financial Services', 'Design', 'Artificial Intelligence', 'Cloud Computing'].map(industry => (
                        <TouchableOpacity
                          key={industry}
                          style={[
                            styles.filterOption,
                            filters.industry === industry && styles.selectedFilterOption
                          ]}
                          onPress={() => setFilters(prev => ({ ...prev, industry }))}
                        >
                          <Text style={[
                            styles.filterOptionText,
                            filters.industry === industry && styles.selectedFilterOptionText
                          ]}>
                            {industry === 'all' ? 'All Industries' : industry}
                          </Text>
                        </TouchableOpacity>
                      ))}
                    </View>
                  </View>

                  {/* Connection Type Filter */}
                  <View style={styles.filterSection}>
                    <Text style={styles.filterSectionTitle}>Connection Type</Text>
                    <View style={styles.filterOptions}>
                      {['all', 'linkedin', 'event', 'referral', 'conference', 'manual'].map(type => (
                        <TouchableOpacity
                          key={type}
                          style={[
                            styles.filterOption,
                            filters.connectionType === type && styles.selectedFilterOption
                          ]}
                          onPress={() => setFilters(prev => ({ ...prev, connectionType: type }))}
                        >
                          <Text style={[
                            styles.filterOptionText,
                            filters.connectionType === type && styles.selectedFilterOptionText
                          ]}>
                            {type === 'all' ? 'All Types' : 
                             type === 'linkedin' ? 'LinkedIn' :
                             type === 'event' ? 'Event' :
                             type === 'referral' ? 'Referral' :
                             type === 'conference' ? 'Conference' :
                             type === 'manual' ? 'Manual' : type}
                          </Text>
                        </TouchableOpacity>
                      ))}
                    </View>
                  </View>

                  {/* Connection Strength Filter */}
                  <View style={styles.filterSection}>
                    <Text style={styles.filterSectionTitle}>Connection Strength</Text>
                    <View style={styles.filterOptions}>
                      {['all', 'strong', 'medium', 'weak', 'new'].map(strength => (
                        <TouchableOpacity
                          key={strength}
                          style={[
                            styles.filterOption,
                            filters.strength === strength && styles.selectedFilterOption
                          ]}
                          onPress={() => setFilters(prev => ({ ...prev, strength }))}
                        >
                          <Text style={[
                            styles.filterOptionText,
                            filters.strength === strength && styles.selectedFilterOptionText
                          ]}>
                            {strength === 'all' ? 'All Strengths' : 
                             strength.charAt(0).toUpperCase() + strength.slice(1)}
                          </Text>
                        </TouchableOpacity>
                      ))}
                    </View>
                  </View>
                </>
              ) : (
                <>
                  {/* Event Type Filter */}
                  <View style={styles.filterSection}>
                    <Text style={styles.filterSectionTitle}>Event Type</Text>
                    <View style={styles.filterOptions}>
                      {['all', 'Meetup', 'Career Fair', 'Conference', 'Networking'].map(type => (
                        <TouchableOpacity
                          key={type}
                          style={[
                            styles.filterOption,
                            filters.eventType === type && styles.selectedFilterOption
                          ]}
                          onPress={() => setFilters(prev => ({ ...prev, eventType: type }))}
                        >
                          <Text style={[
                            styles.filterOptionText,
                            filters.eventType === type && styles.selectedFilterOptionText
                          ]}>
                            {type === 'all' ? 'All Types' : type}
                          </Text>
                        </TouchableOpacity>
                      ))}
                    </View>
                  </View>

                  {/* Event Status Filter */}
                  <View style={styles.filterSection}>
                    <Text style={styles.filterSectionTitle}>Event Status</Text>
                    <View style={styles.filterOptions}>
                      {['all', 'upcoming', 'past', 'cancelled'].map(status => (
                        <TouchableOpacity
                          key={status}
                          style={[
                            styles.filterOption,
                            filters.eventStatus === status && styles.selectedFilterOption
                          ]}
                          onPress={() => setFilters(prev => ({ ...prev, eventStatus: status }))}
                        >
                          <Text style={[
                            styles.filterOptionText,
                            filters.eventStatus === status && styles.selectedFilterOptionText
                          ]}>
                            {status === 'all' ? 'All Status' : 
                             status.charAt(0).toUpperCase() + status.slice(1)}
                          </Text>
                        </TouchableOpacity>
                      ))}
                    </View>
                  </View>
                </>
              )}
            </ScrollView>

            <View style={styles.filterActions}>
              <TouchableOpacity
                style={styles.clearFiltersButton}
                onPress={() => {
                  setFilters({
                    industry: 'all',
                    location: 'all',
                    connectionType: 'all',
                    strength: 'all',
                    eventType: 'all',
                    eventStatus: 'all',
                  });
                }}
              >
                <Text style={styles.clearFiltersText}>Clear All</Text>
              </TouchableOpacity>
              <TouchableOpacity
                style={styles.applyFiltersButton}
                onPress={() => setShowFilterModal(false)}
              >
                <Text style={styles.applyFiltersText}>Apply Filters</Text>
              </TouchableOpacity>
            </View>
          </View>
        </View>
      </Modal>
      {/* Chat Modal */}
      {renderChatModal()}
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  safeArea: {
    flex: 1,
    backgroundColor: '#667eea',
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: '#667eea',
    paddingHorizontal: 16,
    paddingVertical: 12,
  },
  backButton: {
    padding: 8,
  },
  headerTitle: {
    fontSize: 18,
    fontWeight: '600',
    color: '#ffffff',
    flex: 1,
    textAlign: 'center',
    marginHorizontal: 16,
  },
  headerActions: {
    flexDirection: 'row',
    gap: 8,
  },
  headerAction: {
    padding: 8,
  },
  loadingContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 20,
  },
  loadingText: {
    marginTop: 16,
    fontSize: 16,
    color: '#64748B',
    textAlign: 'center',
  },
  sourceIndicator: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#f0f8ff',
    paddingHorizontal: 12,
    paddingVertical: 8,
    marginHorizontal: 16,
    marginTop: 8,
    borderRadius: 8,
    gap: 8,
  },
  sourceText: {
    fontSize: 14,
    color: '#007AFF',
    fontWeight: '500',
  },
  statsScrollView: {
    marginTop: 8,
  },
  statsContainer: {
    paddingHorizontal: 16,
    gap: 12,
  },
  statCard: {
    backgroundColor: '#ffffff',
    borderRadius: 12,
    padding: 16,
    alignItems: 'center',
    minWidth: 100,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.05,
    shadowRadius: 2,
    elevation: 1,
  },
  statNumber: {
    fontSize: 20,
    fontWeight: '700',
    color: '#0e4e96',
    marginBottom: 4,
  },
  statLabel: {
    fontSize: 12,
    color: '#64748B',
    textAlign: 'center',
  },
  searchContainer: {
    paddingHorizontal: 16,
    paddingVertical: 12,
  },
  searchBar: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#ffffff',
    borderRadius: 12,
    paddingHorizontal: 16,
    paddingVertical: 12,
    gap: 12,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.05,
    shadowRadius: 2,
    elevation: 1,
  },
  searchInput: {
    flex: 1,
    fontSize: 16,
    color: '#1E293B',
  },
  tabContainer: {
    flexDirection: 'row',
    paddingHorizontal: 16,
    marginBottom: 8,
    gap: 8,
  },
  tab: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#ffffff',
    borderRadius: 12,
    paddingHorizontal: 16,
    paddingVertical: 12,
    gap: 8,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.05,
    shadowRadius: 2,
    elevation: 1,
  },
  activeTab: {
    backgroundColor: '#0e4e96',
  },
  tabText: {
    fontSize: 14,
    fontWeight: '500',
    color: '#64748B',
    flex: 1,
  },
  activeTabText: {
    color: '#ffffff',
  },
  tabBadge: {
    backgroundColor: '#E2E8F0',
    borderRadius: 10,
    paddingHorizontal: 6,
    paddingVertical: 2,
    minWidth: 20,
    alignItems: 'center',
  },
  activeTabBadge: {
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
  },
  tabBadgeText: {
    fontSize: 12,
    fontWeight: '600',
    color: '#64748B',
  },
  activeTabBadgeText: {
    color: '#ffffff',
  },
  listContainer: {
    padding: 16,
  },
  contactItem: {
    backgroundColor: '#ffffff',
    borderRadius: 12,
    marginBottom: 12,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 3,
  },
  contactContent: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: 16,
  },
  contactAvatar: {
    width: 50,
    height: 50,
    borderRadius: 25,
    marginRight: 12,
  },
  contactInfo: {
    flex: 1,
  },
  contactName: {
    fontSize: 16,
    fontWeight: '600',
    color: '#1E293B',
    marginBottom: 2,
  },
  contactTitle: {
    fontSize: 14,
    color: '#64748B',
    marginBottom: 2,
  },
  contactCompany: {
    fontSize: 13,
    color: '#94A3B8',
    marginBottom: 6,
  },
  contactMeta: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
  },
  strengthBadge: {
    paddingHorizontal: 8,
    paddingVertical: 2,
    borderRadius: 10,
  },
  strengthText: {
    fontSize: 10,
    fontWeight: '600',
    color: '#ffffff',
  },
  mutualConnections: {
    fontSize: 11,
    color: '#94A3B8',
  },
  contactActions: {
    flexDirection: 'row',
    gap: 8,
  },
  actionButton: {
    padding: 8,
    borderRadius: 8,
    backgroundColor: '#F8FAFC',
  },
  eventItem: {
    backgroundColor: '#ffffff',
    borderRadius: 12,
    marginBottom: 12,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 3,
  },
  eventContent: {
    padding: 16,
  },
  eventImage: {
    width: '100%',
    height: 120,
    borderRadius: 8,
    marginBottom: 12,
  },
  eventInfo: {
    flex: 1,
  },
  eventTitle: {
    fontSize: 16,
    fontWeight: '600',
    color: '#1E293B',
    marginBottom: 4,
  },
  eventType: {
    fontSize: 14,
    color: '#64748B',
    marginBottom: 8,
  },
  eventDetails: {
    gap: 4,
    marginBottom: 8,
  },
  eventDetailRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
  },
  eventDetailText: {
    fontSize: 12,
    color: '#64748B',
  },
  eventMeta: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  eventStatusBadge: {
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 12,
  },
  eventStatusText: {
    fontSize: 11,
    fontWeight: '600',
    color: '#ffffff',
  },
  eventPrice: {
    fontSize: 14,
    fontWeight: '600',
    color: '#0e4e96',
  },
  rsvpBadge: {
    position: 'absolute',
    top: 16,
    right: 16,
    backgroundColor: '#ffffff',
    borderRadius: 15,
    padding: 4,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.1,
    shadowRadius: 2,
    elevation: 2,
  },
  emptyState: {
    alignItems: 'center',
    justifyContent: 'center',
    padding: 40,
  },
  emptyStateTitle: {
    fontSize: 20,
    fontWeight: '600',
    color: '#1E293B',
    marginTop: 16,
    marginBottom: 8,
  },
  emptyStateMessage: {
    fontSize: 14,
    color: '#64748B',
    textAlign: 'center',
    lineHeight: 20,
    marginBottom: 24,
  },
  emptyStateButton: {
    backgroundColor: '#0e4e96',
    paddingHorizontal: 24,
    paddingVertical: 12,
    borderRadius: 8,
  },
  emptyStateButtonText: {
    fontSize: 14,
    fontWeight: '600',
    color: '#ffffff',
  },
  modalContainer: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    justifyContent: 'flex-end',
  },
  contactModalContent: {
    backgroundColor: '#ffffff',
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
    maxHeight: '90%',
  },
  eventModalContent: {
    backgroundColor: '#ffffff',
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
    maxHeight: '90%',
  },
  addContactModalContent: {
    backgroundColor: '#ffffff',
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
    maxHeight: '90%',
  },
  filterModalContent: {
    backgroundColor: '#ffffff',
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
    maxHeight: '70%',
  },
  modalHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 20,
    borderBottomWidth: 1,
    borderBottomColor: '#F1F5F9',
  },
  modalTitle: {
    fontSize: 18,
    fontWeight: '600',
    color: '#1E293B',
  },
  contactDetails: {
    padding: 20,
  },
  contactDetailHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 24,
  },
  contactDetailAvatar: {
    width: 80,
    height: 80,
    borderRadius: 40,
    marginRight: 16,
  },
  contactDetailInfo: {
    flex: 1,
  },
  contactDetailName: {
    fontSize: 20,
    fontWeight: '600',
    color: '#1E293B',
    marginBottom: 4,
  },
  contactDetailTitle: {
    fontSize: 16,
    color: '#64748B',
    marginBottom: 2,
  },
  contactDetailCompany: {
    fontSize: 14,
    color: '#94A3B8',
    marginBottom: 8,
  },
  contactDetailMeta: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  contactSection: {
    marginBottom: 24,
  },
  contactSectionTitle: {
    fontSize: 16,
    fontWeight: '600',
    color: '#1E293B',
    marginBottom: 12,
  },
  contactDetailRow: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 8,
    gap: 12,
  },
  contactDetailText: {
    fontSize: 14,
    color: '#64748B',
    flex: 1,
  },
  skillsContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 8,
  },
  skillTag: {
    backgroundColor: '#E2E8F0',
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 12,
  },
  skillTagText: {
    fontSize: 12,
    color: '#64748B',
  },
  contactBio: {
    fontSize: 14,
    color: '#64748B',
    lineHeight: 20,
  },
  contactNotes: {
    fontSize: 14,
    color: '#64748B',
    lineHeight: 20,
    fontStyle: 'italic',
  },
  tagsContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 8,
  },
  tag: {
    backgroundColor: '#0e4e96',
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 12,
  },
  tagText: {
    fontSize: 12,
    color: '#ffffff',
    fontWeight: '500',
  },
  contactModalActions: {
    padding: 20,
    borderTopWidth: 1,
    borderTopColor: '#F1F5F9',
  },
  deleteContactButton: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: 12,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: '#EF4444',
    gap: 8,
  },
  deleteContactText: {
    fontSize: 14,
    fontWeight: '500',
    color: '#EF4444',
  },
  eventDetails: {
    padding: 20,
  },
  eventDetailImage: {
    width: '100%',
    height: 150,
    borderRadius: 8,
    marginBottom: 16,
  },
  eventDetailHeader: {
    marginBottom: 20,
  },
  eventDetailTitle: {
    fontSize: 20,
    fontWeight: '600',
    color: '#1E293B',
    marginBottom: 4,
  },
  eventDetailType: {
    fontSize: 16,
    color: '#64748B',
    marginBottom: 2,
  },
  eventDetailOrganizer: {
    fontSize: 14,
    color: '#94A3B8',
  },
  eventSection: {
    marginBottom: 20,
  },
  eventSectionTitle: {
    fontSize: 16,
    fontWeight: '600',
    color: '#1E293B',
    marginBottom: 12,
  },
  eventLocationInfo: {
    flex: 1,
  },
  eventAddress: {
    fontSize: 11,
    color: '#94A3B8',
    marginTop: 2,
  },
  eventDescription: {
    fontSize: 14,
    color: '#64748B',
    lineHeight: 20,
  },
  eventTagsContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 8,
  },
  eventTag: {
    backgroundColor: '#E2E8F0',
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 12,
  },
  eventTagText: {
    fontSize: 12,
    color: '#64748B',
  },
  eventModalActions: {
    padding: 20,
    borderTopWidth: 1,
    borderTopColor: '#F1F5F9',
  },
  rsvpButton: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: 12,
    borderRadius: 8,
    gap: 8,
  },
  rsvpButtonActive: {
    backgroundColor: '#0e4e96',
  },
  rsvpButtonInactive: {
    backgroundColor: '#ffffff',
    borderWidth: 1,
    borderColor: '#0e4e96',
  },
  rsvpButtonText: {
    fontSize: 14,
    fontWeight: '500',
  },
  rsvpButtonTextActive: {
    color: '#ffffff',
  },
  rsvpButtonTextInactive: {
    color: '#0e4e96',
  },
  addContactForm: {
    padding: 20,
  },
  formSection: {
    marginBottom: 16,
  },
  formLabel: {
    fontSize: 14,
    fontWeight: '500',
    color: '#1E293B',
    marginBottom: 8,
  },
  formInput: {
    borderWidth: 1,
    borderColor: '#E2E8F0',
    borderRadius: 8,
    paddingHorizontal: 12,
    paddingVertical: 10,
    fontSize: 14,
    color: '#1E293B',
  },
  formTextArea: {
    height: 80,
    textAlignVertical: 'top',
  },
  addContactActions: {
    flexDirection: 'row',
    padding: 20,
    borderTopWidth: 1,
    borderTopColor: '#F1F5F9',
    gap: 12,
  },
  cancelButton: {
    flex: 1,
    paddingVertical: 12,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: '#E2E8F0',
    alignItems: 'center',
  },
  cancelButtonText: {
    fontSize: 14,
    fontWeight: '500',
    color: '#64748B',
  },
  addButton: {
    flex: 1,
    paddingVertical: 12,
    borderRadius: 8,
    backgroundColor: '#0e4e96',
    alignItems: 'center',
  },
  addButtonText: {
    fontSize: 14,
    fontWeight: '500',
    color: '#ffffff',
  },
  filterContent: {
    padding: 20,
  },
  filterSection: {
    marginBottom: 24,
  },
  filterSectionTitle: {
    fontSize: 16,
    fontWeight: '600',
    color: '#1E293B',
    marginBottom: 12,
  },
  filterOptions: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 8,
  },
  filterOption: {
    paddingHorizontal: 12,
    paddingVertical: 8,
    borderRadius: 16,
    borderWidth: 1,
    borderColor: '#E2E8F0',
    backgroundColor: '#ffffff',
  },
  selectedFilterOption: {
    backgroundColor: '#0e4e96',
    borderColor: '#0e4e96',
  },
  filterOptionText: {
    fontSize: 12,
    fontWeight: '500',
    color: '#64748B',
  },
  selectedFilterOptionText: {
    color: '#ffffff',
  },
  filterActions: {
    flexDirection: 'row',
    padding: 20,
    borderTopWidth: 1,
    borderTopColor: '#F1F5F9',
    gap: 12,
  },
  clearFiltersButton: {
    flex: 1,
    paddingVertical: 12,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: '#E2E8F0',
    alignItems: 'center',
  },
  clearFiltersText: {
    fontSize: 14,
    fontWeight: '500',
    color: '#64748B',
  },
  applyFiltersButton: {
    flex: 1,
    paddingVertical: 12,
    borderRadius: 8,
    backgroundColor: '#0e4e96',
    alignItems: 'center',
  },
  applyFiltersText: {
    fontSize: 14,
    fontWeight: '500',
    color: '#ffffff',
  },
});